import { render, staticRenderFns } from "./JobMessageTab.vue?vue&type=template&id=266ac9be&"
import script from "./JobMessageTab.vue?vue&type=script&lang=js&"
export * from "./JobMessageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports